import { useEffect } from 'react';
import SitePage from '../components/SitePage';
import '../App.css';
import '../styles/admin-page.css';

function AdminPage({
  isAuthenticated,
  isCheckingAdminSession,
  loginId,
  password,
  loginError,
  isLoggingIn,
  uploadStatus,
  assets,
  assetsError,
  onLoginIdChange,
  onPasswordChange,
  onLogin,
  onLogout,
  onRefreshAssets,
  onUpload,
}) {
  useEffect(() => {
    document.body.classList.add('has-admin-bar');
    return () => document.body.classList.remove('has-admin-bar');
  }, []);

  const handleUpload = (assetKey, file) => {
    if (onUpload) onUpload(assetKey, file);
  };

  if (isCheckingAdminSession) {
    return (
      <div className="admin-login-wrap">
        <div className="admin-login-box">
          <h2>관리자 인증 확인 중...</h2>
        </div>
      </div>
    );
  }

  // 로그인 전 → 로그인 화면
  if (!isAuthenticated) {
    return (
      <div className="admin-login-wrap">
        <form className="admin-login-box" onSubmit={onLogin}>
          <h2>관리자 로그인</h2>
          <input
            type="text"
            placeholder="아이디"
            value={loginId}
            onChange={(e) => onLoginIdChange(e.target.value)}
            autoComplete="username"
          />
          <input
            type="password"
            placeholder="비밀번호"
            value={password}
            onChange={(e) => onPasswordChange(e.target.value)}
            autoComplete="current-password"
          />
          <button type="submit" disabled={isLoggingIn}>
            {isLoggingIn ? '로그인 중...' : '로그인'}
          </button>
          {loginError && <p className="admin-error">{loginError}</p>}
          {assetsError && <p className="admin-error">{assetsError}</p>}
          <p style={{ marginTop: 16, fontSize: '0.85rem', color: '#888' }}>
            <a href="/">← 사용자 페이지로</a>
          </p>
        </form>
      </div>
    );
  }

  // 로그인 후 → 동일한 레이아웃 + 상단 관리자 바
  return (
    <>
      <div className="admin-bar">
        <span>
          <strong>관리자 모드</strong>
          &nbsp;— 이미지 위에 커서를 올리면 <strong>변경 버튼</strong>이 나타납니다
        </span>
        <div className="admin-bar-right">
          {Object.entries(uploadStatus).map(([key, msg]) =>
            msg ? <small key={key} style={{ color: '#a5f3fc' }}>{key}: {msg}</small> : null
          )}
          {assetsError && <small style={{ color: '#fca5a5' }}>{assetsError}</small>}
          <button type="button" onClick={onRefreshAssets}>새로고침</button>
          <a href="/" style={{ color: '#c4b5fd', fontSize: '0.82rem' }}>사용자 페이지 →</a>
          <button type="button" className="logout-btn" onClick={onLogout}>로그아웃</button>
        </div>
      </div>

      <SitePage assets={assets} isAdmin={true} onUpload={handleUpload} />
    </>
  );
}

export default AdminPage;

